import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommunityPolicy } from 'src/app/models/community-policy';
import { CommunityPolicyResourceService } from './community-policy-resource.service';

@Injectable({
    providedIn: 'root',
})
export class CommunityPolicyService {
    policy;

    private hasFetchedPolicy = false;

    constructor(private policyResource: CommunityPolicyResourceService) {}

    getPolicy(): Observable<CommunityPolicy> {
        if (!this.hasFetchedPolicy) {
            // TODO: This will need to get changed back to using a caching
            //       strategy so that its not pulling the contents down each
            //       each time we need to get the community policy.
            return this.policyResource.getCommunityPolicy();
        }
        return new Observable<CommunityPolicy>();
    }
}
